/*
 * @Descripttion: 供应商订单发票录入页
 * @Author: 曹博
 * @Date: 2023-11-28 10:16:20
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-29 11:54:17
 */

import { Button, Row, Space, Tooltip } from 'antd'
import Search from '../../../components/SearchFilter'
import TableAntd from '../../../components/TableAntd'
import UseSupplierInvoiceEntryHook from './hooks'
import Styles from './styles.module.scss'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import moment from 'moment'
import IframeModal from '../../../components/IframeModal'

// 跳转至供应商订单详情页
export const toAssureOperationRender = (text: any, record: any) => {
  return <Link to={`/srm/ordersupplierdetail?id=${record.id}`}>{text}</Link>
}

const SupplierInvoiceEntry = () => {
  const {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    changeInvoiceTip,
    exportDetails,
  } = UseSupplierInvoiceEntryHook()
  const { dataSource, invoiceTip, pages, loading } = state

  const columns = [
    {
      key: 'code',
      title: '采购订单号',
      render: toAssureOperationRender,
    },
    {
      key: 'createTime',
      dataIndex: 'createTime',
      title: '创建时间',
      render: (text: number) => text && moment(text).format('YYYY-MM-DD HH:mm'),
    },
    {
      key: 'receiveMan',
      dataIndex: 'receiveMan',
      title: '收件人',
    },
    {
      key: 'number',
      title: '结算件数',
    },
    {
      key: 'finalPrice',
      dataIndex: 'finalPrice',
      title: '最终结算金额',
    },
  ]
  return (
    <div className={Styles['container']}>
      <Search
        fieldsData={['supplierOrderCode', 'receiveMan']}
        onSearch={handleSearchClick}
        keyName="SUPPLIERINVOICEENTRY"
        ScreenKey="SUPPLIERINVOICEENTRY"
      />
      <Row justify="space-between" className={Styles['info-row']}>
        <Space style={{ cursor: 'pointer' }}>
          <Tooltip title="订单内物料全部入库">
            <QuestionCircleOutlined style={{ marginRight: '8px' }} />
            可开票订单条件
          </Tooltip>
        </Space>
        <Space>
          <Button size="middle" onClick={() => changeInvoiceTip(true)}>
            开票要求
          </Button>
          <Button size="middle" onClick={exportDetails}>
            明细导出
          </Button>
          <Button type="primary" size="middle" onClick={handleBatchRecord}>
            发票录入
          </Button>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource.data}
        listColumn={columns}
        loading={loading}
        Y={340}
        pagination={{
          total: dataSource.total,
          current: pages.pageNo,
          pagesize: pages.pageSize,
          onChange: handlePaginationChange,
        }}
        showSize={true}
        onChangeCheck={handleTableChangeCheck}
      ></TableAntd>
      {/* 开票要求 */}
      <IframeModal
        open={invoiceTip}
        closeModal={() => changeInvoiceTip(false)}
        srcUrl="https://alidocs.dingtalk.com/i/p/Dnb9XJD9MAgGyAp7JqzqA8EYxn9MnzYE"
      />
    </div>
  )
}

export default SupplierInvoiceEntry
/*
 * @Descripttion: 供应商订单发票录入页
 * @Author: 曹博
 * @Date: 2023-11-28 10:16:20
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-29 11:54:17
 */

import { Button, Row, Space, Tooltip } from 'antd'
import Search from '../../../components/SearchFilter'
import TableAntd from '../../../components/TableAntd'
import UseSupplierInvoiceEntryHook from './hooks'
import Styles from './styles.module.scss'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import moment from 'moment'
import IframeModal from '../../../components/IframeModal'

// 跳转至供应商订单详情页
export const toAssureOperationRender = (text: any, record: any) => {
  return <Link to={`/srm/ordersupplierdetail?id=${record.id}`}>{text}</Link>
}

const SupplierInvoiceEntry = () => {
  const {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    changeInvoiceTip,
    exportDetails,
  } = UseSupplierInvoiceEntryHook()
  const { dataSource, invoiceTip, pages, loading } = state

  const columns = [
    {
      key: 'code',
      title: '采购订单号',
      render: toAssureOperationRender,
    },
    {
      key: 'createTime',
      dataIndex: 'createTime',
      title: '创建时间',
      render: (text: number) => text && moment(text).format('YYYY-MM-DD HH:mm'),
    },
    {
      key: 'receiveMan',
      dataIndex: 'receiveMan',
      title: '收件人',
    },
    {
      key: 'number',
      title: '结算件数',
    },
    {
      key: 'finalPrice',
      dataIndex: 'finalPrice',
      title: '最终结算金额',
    },
  ]
  return (
    <div className={Styles['container']}>
      <Search
        fieldsData={['supplierOrderCode', 'receiveMan']}
        onSearch={handleSearchClick}
        keyName="SUPPLIERINVOICEENTRY"
        ScreenKey="SUPPLIERINVOICEENTRY"
      />
      <Row justify="space-between" className={Styles['info-row']}>
        <Space style={{ cursor: 'pointer' }}>
          <Tooltip title="订单内物料全部入库">
            <QuestionCircleOutlined style={{ marginRight: '8px' }} />
            可开票订单条件
          </Tooltip>
        </Space>
        <Space>
          <Button size="middle" onClick={() => changeInvoiceTip(true)}>
            开票要求
          </Button>
          <Button size="middle" onClick={exportDetails}>
            明细导出
          </Button>
          <Button type="primary" size="middle" onClick={handleBatchRecord}>
            发票录入
          </Button>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource.data}
        listColumn={columns}
        loading={loading}
        Y={340}
        pagination={{
          total: dataSource.total,
          current: pages.pageNo,
          pagesize: pages.pageSize,
          onChange: handlePaginationChange,
        }}
        showSize={true}
        onChangeCheck={handleTableChangeCheck}
      ></TableAntd>
      {/* 开票要求 */}
      <IframeModal
        open={invoiceTip}
        closeModal={() => changeInvoiceTip(false)}
        srcUrl="https://alidocs.dingtalk.com/i/p/Dnb9XJD9MAgGyAp7JqzqA8EYxn9MnzYE"
      />
    </div>
  )
}

export default SupplierInvoiceEntry
